const StateJS = require('@steelbreeze/state');
const EventEmitter = require('events').EventEmitter;
const Enum = require('./enums');
const Event = require('./events');

/*
 * Definition for type : BrowserRequirements
 */

function BrowserRequirements(name, root) {
  this.bus = (root === null) ? new EventEmitter() : root.bus;
  this.name = name;
  this.root = (root === null) ? this : root;
  this.ready = false;

  this.build(name);
}

BrowserRequirements.prototype.build = function (session) {
  /* State machine (states and regions) */
  /* Building root component */
  this._statemachine = new StateJS.State('default_statemachine');
  const _initial_BrowserRequirements = new StateJS.PseudoState('_initial', this._statemachine, StateJS.PseudoStateKind.Initial);
  const BrowserRequirements_null_Check = new StateJS.State('Check', this._statemachine).entry(() => {
    if (this.hasWebSocket() && this.hasMediaSource() && this.hasH264()) {
      this.bus.emit('internalPort', new Event.InternalSupported_BrowserRequirements(this.name, 'internalPort'));
    } else {
      this.bus.emit('internalPort', new Event.InternalUnsupported_BrowserRequirements(this.name, 'internalPort'));
    }
  });
  const BrowserRequirements_null_Supported = new StateJS.State('Supported', this._statemachine);
  const BrowserRequirements_null_Unsupported = new StateJS.State('Unsupported', this._statemachine).entry(() => {
    this.onUnsupported();
    setImmediate(() => this._stop());
  });
  _initial_BrowserRequirements.to(BrowserRequirements_null_Check);
  BrowserRequirements_null_Check.to(BrowserRequirements_null_Unsupported).on(Event.MediaSourceUnsupported_MediaSourceMsg).when((mediaSourceUnsupported) => mediaSourceUnsupported.port === 'mediaSource' && mediaSourceUnsupported.type === 'mediaSourceUnsupported');
  BrowserRequirements_null_Supported.to(BrowserRequirements_null_Unsupported).on(Event.MediaSourceUnsupported_MediaSourceMsg).when((mediaSourceUnsupported) => mediaSourceUnsupported.port === 'mediaSource' && mediaSourceUnsupported.type === 'mediaSourceUnsupported');
  BrowserRequirements_null_Check.to(BrowserRequirements_null_Supported).on(Event.InternalSupported_BrowserRequirements).when((internalSupported) => internalSupported.port === 'internalPort' && internalSupported.type === 'internalSupported');
  BrowserRequirements_null_Check.to(BrowserRequirements_null_Unsupported).on(Event.InternalUnsupported_BrowserRequirements).when((internalUnsupported) => internalUnsupported.port === 'internalPort' && internalUnsupported.type === 'internalUnsupported');
};
BrowserRequirements.prototype.onUnsupported = function () {};

BrowserRequirements.prototype.hasWebSocket = function () {
  let result_var = false;
  const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
  let protoBin;

  if ('WebSocket' in window) {
    protoBin = 'binaryType' in WebSocket.prototype;
    if (protoBin) {
      result_var = !!protoBin;
    } else {
      try {
        result_var = !!(new WebSocket(`${protocol}://.`).binaryType);
      } catch (error) {}
    }
  }
  return result_var;
};

BrowserRequirements.prototype.hasMediaSource = function () {
  return ('ManagedMediaSource' in window || 'MediaSource' in window);
};

BrowserRequirements.prototype.hasH264 = function () {
  let elem = document.createElement('video');
  let result = false;
  try {
    result = !!elem.canPlayType;
    if (result) {
      result = !!elem.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, '');
    }
  } catch (error) {}
  elem = null;

  return result;
};

BrowserRequirements.prototype._stop = function () {
  this.root = null;
  this.ready = false;
  this.stopped = true;
};

BrowserRequirements.prototype._delete = function () {
  this._statemachine = null;
  this._null_instance = null;
  this.bus.removeAllListeners();
};

BrowserRequirements.prototype._init = function () {
  this._null_instance = new StateJS.Instance('null_instance', this._statemachine);
  this.ready = true;
};

BrowserRequirements.prototype._receive = function (msg) {
  if (this.ready) {
    this._null_instance.evaluate(msg);
  } else if (!this.stopped) {
    setTimeout(() => this._receive(msg), 4);
  }
};

BrowserRequirements.prototype.toString = function () {
  let result = `instance ${this.name}:${this.constructor.name}\n`;
  result += '';
  return result;
};

module.exports = BrowserRequirements;
